export default __webpack_public_path__ + "static/media/adp-logo.6f2402e9.svg";